import {
  useState,
  useEffect,
  // useImperativeHandle,
  forwardRef,
  useRef,
} from "react";
import useChatSessionStore from "../../../../store/chatSessionStore";
import useChatMessageStore from "../../../../store/chatMessagesStore";
import React from "react";
import styles from "../chatDrawer.module.css";
interface HistoryItem {
  id: string;
  project_id: string;
  title: string;
  description: string;
  timestamp: string;
  selected?: boolean;
}

export interface HistoryModalConfig {
  title?: string;
  backIconUrl?: string;
  closeIconUrl?: string;
  searchPlaceholder?: string;
  noResultsText?: string;
}

export interface HistoryModalProps extends HistoryModalConfig {
  isOpen: boolean;
  aiAssistantName?: string;
  onClose: () => void;
  initialItems?: HistoryItem[];
  onSelectSession?: (
    indexId: number,
    projectId: string,
    totalCount: number
  ) => void;
  isExpanded?: boolean;
  hideHeader?: boolean;
}

const HistoryModal = forwardRef(function HistoryModal(
  {
    isOpen,
    onClose,
    aiAssistantName = "AI",
    // initialItems = [],
    onSelectSession,
    title = "History",
    backIconUrl,
    closeIconUrl,
    searchPlaceholder = "Search in Projects",
    noResultsText = "No history found.",
  }: HistoryModalProps,
  // ref
) {
  const [historyItems, setHistoryItems] = useState<HistoryItem[]>([]);
  const [filterdHistoryItems, setFilterdHistoryItems] = useState<HistoryItem[]>([]);
  const [_isSearching, setIsSearching] = useState(false); // Add this state

  const {
    chatSessions,
    fetchChatSessions,
    isLoading,
    selectedSessionId,
    setSelectedSessionId,
    setSessionIsOn,
    // dropdownSelectedProjectId,
    setDropdownSelectedProjectId,
    historySearch,
    setHistorySearch,
  } = useChatSessionStore();
  const { setIsWebEnabled } = useChatMessageStore();
  const [isClosing, setIsClosing] = useState(false);

  // // Debounce search
  // useEffect(() => {
  //   const handler = setTimeout(() => {
  //     // fetchChatSessions(search.trim() || "");
  //   }, 400);
  //   return () => clearTimeout(handler);
  // }, [search, fetchChatSessions]);

  // Update historyItems when API returns data
  useEffect(() => {
    if (chatSessions && chatSessions && Array.isArray(chatSessions) && !_isSearching) {

      setHistoryItems(
        chatSessions.map((session) => ({
          id: session._id,
          project_id: session.project_id || session.project_name || session._id,
          title: (session.session_title === 'default' || session.project_name === 'default') ? 'ProSchool.ai' : session.session_title || session.project_name,
          description: session.last_message || "No messages yet.",
          timestamp: session.timestamp
            ? new Date(session.timestamp).toLocaleString()
            : "",
        }))
      );


      setFilterdHistoryItems(
        chatSessions.map((session) => ({
          id: session._id,
          project_id: session.project_id || session.project_name || session._id,
          title: (session.session_title === 'default' || session.project_name === 'default') ? 'ProSchool.ai' : session.session_title || session.project_name,
          description: session.last_message || "No messages yet.",
          timestamp: session.timestamp
            ? new Date(session.timestamp).toLocaleString()
            : "",
        }))
      );
    }

  }, [chatSessions]);


  useEffect(() => {

    return () => {
      setHistorySearch('')
    };
  }, []);



  const selectItem = (id: string, project_id: string) => {
    setSessionIsOn(true);

    const selected =
      chatSessions && Array.isArray(chatSessions)
        ? chatSessions.find((session: any) => session._id === id)
        : undefined;

    // Use project_name for dropdown to match what onSelectSession expects
    const projectNameForDropdown = selected?.project_name || project_id;

    setSelectedSessionId(project_id);
    setDropdownSelectedProjectId(projectNameForDropdown); // <-- keep dropdown in sync with project_name
    setIsWebEnabled(false); // Reset to work mode when changing project

    if (selected && selected.index_id && onSelectSession) {
      onSelectSession(
        selected.index_id,
        selected.project_name,
        selected.total_sessions_count
      );
    }
    handleCloseWithAnimation();
  };

  // useImperativeHandle(ref, () => ({
  //   fetchChatSessions,
  // }));

  // Animation close handler
  const handleCloseWithAnimation = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsClosing(false);
      onClose();
    }, 300); // Match with transition duration
  };
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleInputChange = (value: string) => {
    setHistorySearch(value);



    // Only set searching state if there's actual search text
    if (value.trim()) {
      setIsSearching(true);
      const filtered = historyItems.filter(item =>
        item.title.toLowerCase().includes(value.trim().toLowerCase())
      );

      setFilterdHistoryItems(filtered);
    } else {
      setIsSearching(false);
    }

    if (debounceRef.current) clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(() => {
      fetchChatSessions(value.trim() || "");
    }, 300); // 300ms debounce
  };
  // if (!isOpen && !isClosing) return null;

  // Determine if we should show "no results" message (when searching)
  const shouldShowNoResults =
    !isLoading && filterdHistoryItems.length === 0 && historySearch.trim() !== ""; // Only show when actively searching

  // Determine if we should show "no history available" message (when no data at all)
  const shouldShowNoHistory =
    !isLoading && filterdHistoryItems.length === 0 && historySearch.trim() === ""; // Show when no search and no items

const formatTimestamp = (timestamp: string): string => {
  if (!timestamp) return '';
  
  const date = new Date(timestamp);
  
  // Check if date is valid
  if (isNaN(date.getTime())) {
    console.warn('Invalid timestamp:', timestamp);
    return timestamp; // Return original string as fallback
  }
  
  // Manually format to ensure consistency across all locales
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  
  return `${month}/${day} ${hours}:${minutes} ${ampm}`;
};

  return (
    <div
      className={`
        fixed top-0 right-0 h-full w-full max-w-md bg-white shadow-lg z-[10000]
        transition-transform duration-500 ease-in-out
        ${isOpen && !isClosing ? "translate-x-0" : "translate-x-full"}
      `}
      style={{ maxWidth: 580 }}
    >
      {/* Header */}
      <div className="flex items-center justify-between p-2 sm:p-4 border-b border-gray-200">
        <div className="flex items-center">
          <img
            onClick={handleCloseWithAnimation}
            src={backIconUrl || "/placeholder.svg"}
            alt="History Icon"
            className="mr-2 w-4 sm:w-full cursor-pointer"
          />
          <h2 className="text-[18px] sm:text-lg font-semibold sm:font-medium text-gray-900 mb-0 mt-0">
            {title}
          </h2>
        </div>
        <button
          onClick={handleCloseWithAnimation}
          className="text-gray-400 hover:text-gray-600"
          aria-label="Close modal"
        >
          <img
            src={closeIconUrl || "/placeholder.svg"}
            alt="Close"
            className="w-8 sm:w-full"
          />
        </button>
      </div>
      <div className="p-2 sm:p-4 pb-0 sm:pb-2 me-1">
        <input
          type="text"
          className="w-full p-2 border border-inactive-bg rounded-md text-gray-900 font-normal text-sm placeholder-gray-400 focus:outline-none focus:border-inactive-bg"
          placeholder={searchPlaceholder}
          value={historySearch}
          onChange={(e) => handleInputChange(e.target.value)}
        />
      </div>

      {/* Content */}
      <div className="overflow-y-auto max-h-[80vh] p-2 sm:p-4 me-1">
        {!shouldShowNoHistory && !shouldShowNoResults && filterdHistoryItems && filterdHistoryItems.length > 0 && (
          filterdHistoryItems.map((item) => (
            <div
              key={item.id}
              className={`p-2 sm:p-4 border-b border-gray-100 rounded-lg cursor-pointer mb-1 ${selectedSessionId === item.project_id
                ? "bg-blue-100"
                : "hover:bg-gray-50"
                }`}
              onClick={() => selectItem(item.id, item.project_id || item.id)}
            >
              <div className="flex justify-between items-start mb-1">
                <h3 className="text-[14px] sm:text-sm font-medium text-gray-900">
                  {item.title === "ProSchool.ai" ? aiAssistantName : item.title}
                </h3>
                <span className="text-xs sm:text-xs text-gray-500">
                  {formatTimestamp(item.timestamp)}
                </span>
              </div>
              <p className={`text-xs sm:text-sm text-gray-600${styles.chatHistoryItem}`}>
                {item.description}
              </p>
            </div>
          ))
        )}

        {shouldShowNoHistory && (
          <div className="flex items-center justify-center h-full min-h-[400px]">
            <div className="text-center text-sm text-gray-500">
              No history available
            </div>
          </div>
        )}

        {shouldShowNoResults && (
          <div className="text-center text-xs text-gray-500 py-4">
            {chatSessions &&
              !Array.isArray(chatSessions) &&
              typeof chatSessions === "object" &&
              "message" in chatSessions
              ? (chatSessions as { message: string }).message
              : noResultsText}
          </div>
        )}
      </div>
    </div>
  );
});

export default HistoryModal;
